import { createStore, useStore } from "zustand";

const entryPointStore = createStore((set) => ({
  firstTimeUser: null,
  firstTimeOrganization: null,
  actions: {
    setFirstTimeUser: (value) => set({ firstTimeUser: value }),
    setFirstTimeOrganization: (value) => set({ firstTimeOrganization: value }),
  },
}));

const useEntryPointStore = (selector) => useStore(entryPointStore, selector);

export const useFirstTimeUser = () => useEntryPointStore((state) => state.firstTimeUser);
export const useFirstTimeOrganization = () => useEntryPointStore((state) => state.firstTimeOrganization);

export const useEntryPointActions = () => useEntryPointStore((state) => state.actions);
export const getEntryPointStoreState = () => entryPointStore.getState();
